import { Box, Divider, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, {
  useEffect,
  useState,
  useRef,
  useImperativeHandle,
  forwardRef,
} from 'react';
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  SortDirection,
} from '@mui/material';
import { useStore } from '../../utils/store';
import DeleteForeverIcon from '@mui/icons-material/Delete';
import Constants from '../../utils/constants';
import HttpServices from '../../services/HttpService';

import AlertMessageComponent from '../../components/AlertMessageComponent';

import AddButtonComponent from '../../components/form/AddButtonComponent';

import CrewMobileAssetsListComponent from '../DataManagement/Crews/parts/MobileAssetsList';
import PaginateDataModel from '../../Models/PaginateDataModel';
import SimpleDialogComponent from '../../components/SimpleDialogComponent';
import ShiftSaveButtons from './parts/SaveButtons';
import tabStore from './tabStore';
import SelectFieldComponent from '../../components/form/SelectFieldComponent';

interface MobileAssetsProps {
  currentRecord: any;
  mobileAssetsList: any[];
  goBack: () => void;
  goRefresh: () => void;
  updateShiftStatus: (record: any) => void;
}
export type AssetsRef = {
  handleSave: (type: any) => void;
};
const MobileAssets = forwardRef<AssetsRef, MobileAssetsProps>(
  (
    { currentRecord, goBack, goRefresh, mobileAssetsList, updateShiftStatus },
    ref
  ) => {
    useImperativeHandle(ref, () => ({
      handleSave,
    }));

    const [inProgress, setInProgress] = useState(false);
    const [addMobileAssetDialogOpen, setAddMobileAssetDialogOpen] =
      useState<boolean>(false);
    const [searchQueryMobileAssets, setSearchQueryMobileAssets] =
      useState<any>('');
    const [totalRecordsMobileAssets, setTotalRecordsMobileAssets] =
      useState<number>(0);
    const [shiftMobileAssets, setShiftMobileAssets] = useState<any[]>([]);
    const [selectedMobileAssetsListIds, setSelectedMobileAssetsListIds] =
      useState<any>([]);
    const [selectedMobileAssetsList, setSelectedMobileAssetsList] =
      useState<any>([]);
    const [processing, setProcessing] = useState<boolean>(false);
    const [publishing, setPublishing] = useState<boolean>(false);
    const [paginateMobileAssetList, setPaginateMobileAssetList] =
      useState<PaginateDataModel>({
        limit: Constants.DEFAULT_PAGE_SIZE,
        offset: 0,
      });
    const [orderBy, setOrderBy] = useState<any>('id');
    const [order, setOrder] = useState<SortDirection>('asc');
    const handleOrderBy = (orderByColumn: any) => {
      setOrderBy(orderByColumn);
      // console.log(order);
      // console.log(orderByColumn);
      if (order === 'desc') {
        setOrder('asc');
        return;
      } else {
        setOrder('desc');
        return;
      }
    };
    const { getAdmin } = useStore();

    const [httpError, setHttpError] = useState({
      message: '',
      open: false,
    });
    const hoursList = [
      { id: 0, label: 0, value: 0 },
      { id: 4, label: 4, value: 4 },
      { id: 8, label: 8, value: 8 },
    ];

    const loadData = async () => {
      if (currentRecord) {
        setInProgress(true);

        handleRecords();
        setInProgress(false);
      }
    };
    const handleRecords = () => {
      setShiftMobileAssets(currentRecord.shiftMobileAssets);
      setSelectedMobileAssetsList(currentRecord.shiftMobileAssets);
      const idArray = currentRecord.shiftMobileAssets.map(
        (item: any) => item.mobileAsset.id
      );
      console.log(idArray, '<<<<<<<<<<<<<<<<<');
      setSelectedMobileAssetsListIds(idArray);
    };

    useEffect(() => {
      if (currentRecord) {
        loadData();
      }
    }, [currentRecord]);
    const handleStatus = (row: any) => {
      handleSelectedIds(row.id);
    };
    const handleSelectedIds = async (id: any) => {
      console.log(id);

      setSelectedMobileAssetsListIds((prevItems: any) => {
        const newItems = [...prevItems];
        if (!newItems.includes(id)) {
          newItems.push(id);
        } else {
          newItems.splice(newItems.indexOf(id), 1);
        }
        return newItems;
      });
    };
    const handleMinutesChange = (value: any, index: number, type: string) => {
      setShiftMobileAssets((prevItems: any) => {
        // Create a copy of the current state
        const updatedItems = [...prevItems];
        updatedItems[index] = {
          ...updatedItems[index],
          [type]: parseInt(value) * 60,
        };
        return updatedItems;
      });
      tabStore.updateField('tab1Field', 'updated');
    };
    const handleSaveMobileAssets = async () => {
      let filterData: any[] = mobileAssetsList.filter(
        (item) => selectedMobileAssetsListIds.indexOf(item.id) !== -1
      );
      tabStore.updateField('tab1Field', 'updated');
      const mapped = filterData.map((asset: any) => ({
        shiftMobileAssetId: 0,
        shiftId: currentRecord.shiftId,
        mobileAssetId: asset.id,
        planMinutes: currentRecord.shiftStatusId === 2 ? null : 480,
        actualMinutes: null,
        reviewMinutes: null,
        status: asset.status,
        mobileAsset: {
          id: asset.id,
          assetNumber: asset.assetNumber,
          assetName: asset.assetName,
          assetTypeId: asset.assetTypeId,
          assetCost: '0.00',
          purchaseDate: asset.registrationDate,
          registrationDate: asset.registrationDate,
          nextServiceDate: asset.nextServiceDate,
          isHired: Boolean(asset.isHired),
          contractorId: asset.contractorId,
          resourceItemId: 0,
          isOutofService: false,
          outofServiceFrom: asset.registrationDate,
          outofServiceTo: asset.registrationDate,
        },
      }));

      const existingShiftSelectedIds = shiftMobileAssets.filter(
        (item: any) =>
          selectedMobileAssetsListIds.indexOf(item.mobileAsset.id) !== -1
      );
      // console.log(`selectedMobileAssetsList`);
      // console.log(JSON.stringify(existingShiftSelectedIds));
      // console.log(JSON.stringify(mapped));
      // console.log(`selectedMobileAssetsList`);
      const existingIds = existingShiftSelectedIds.map(
        (item) => item.mobileAssetId
      );

      const newAssets = mapped.filter(
        (item) => !existingIds.includes(item.mobileAssetId)
      );

      const updatedShiftMobileAssets = [
        ...existingShiftSelectedIds,
        ...newAssets,
      ];

      setShiftMobileAssets(updatedShiftMobileAssets);
      // setShiftMobileAssets(mapped);
    };
    const handleSave = async (type: number) => {
      if (type === 0) {
        setProcessing(true);
      } else {
        setPublishing(true);
      }
      tabStore.updateField('tab1Field', '');
      const finalMobileAssets: any = shiftMobileAssets.map((asset: any) => ({
        mobileAssetId: asset.mobileAssetId,
        planMinutes: asset.planMinutes,
        actualMinutes: asset.actualMinutes,
        reviewMinutes: asset.reviewMinutes,
      }));
      const shiftReq: any = {
        shiftId: currentRecord.shiftId,
        mobileAssets: finalMobileAssets,
      };

      const endpoint = Constants.apiURL + Constants.shiftURL + '/assets';

      let response: any;

      try {
        if (currentRecord) {
          response = await HttpServices.post(endpoint, shiftReq, {
            headers: { Authorization: `Bearer ${getAdmin()}` },
          });
        }
        setHttpError({
          open: true,
          message: type === 0 ? 'Saved' : 'Saved successfully',
        });
        if (type === 1) {
          goBack();
        }
        if (type === 3 || type === 4 || type === 1) {
          updateShiftStatus({
            shiftId: currentRecord.shiftId,
            newShiftStatusId: type,
          });
          if (type === 4 || type === 1) {
            goBack();
          }
        }
        goRefresh();
        return true;
      } catch (error: any) {
        console.error(`PATCH Error:`, error);
        setHttpError({
          message: error.message,
          open: true,
        });
        return true;
      } finally {
        setProcessing(false);
        setPublishing(false);
        return true;
      }
    };
    const removeItem = (index: any) => {
      setShiftMobileAssets((prevItems) => {
        const newItems = [...prevItems];
        newItems.splice(index, 1);

        return newItems;
      });
      tabStore.updateField('tab1Field', 'updated');
    };
    const MobileAssetDialogContent = () => {
      return (
        <Box className="row mb-3 mt-2" sx={{ textAlign: 'right' }}>
          <Typography component={'h1'} sx={{ mt: 4, mb: 4, textAlign: 'left' }}>
            Add Mobile Asset
          </Typography>
          <Box sx={{ width: '800px' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 2,
                mt: 2,
              }}
            >
              {/* <SimpleSearchComponent
              onSearch={(event: any) => {
                setSearchQueryMobileAssets(event.target.value);
              }}
              search={searchQueryMobileAssets}
            /> */}
            </Box>
            <CrewMobileAssetsListComponent
              handleStatus={handleStatus}
              recordList={mobileAssetsList}
              selectedRecords={selectedMobileAssetsListIds}
              totalRecords={totalRecordsMobileAssets}
              paginate={paginateMobileAssetList}
              handlePagination={(paginateData: any, type: any) => {
                setPaginateMobileAssetList(paginateData);
              }}
              order={order}
              orderBy={orderBy}
              handleOrderBy={handleOrderBy}
            ></CrewMobileAssetsListComponent>
          </Box>
          <Button
            color="primary"
            sx={{ color: '#fff !important', mt: 3, mb: 3, textAlign: 'right' }}
            variant="contained"
            onClick={() => {
              handleSaveMobileAssets();
              setAddMobileAssetDialogOpen(false);
            }}
          >
            Save
          </Button>
        </Box>
      );
    };
    return (
      <Paper sx={{ width: '100%' }} elevation={0} className="mt-4">
        <Box
          sx={{
            padding: '24px 16px 16px 16px',
            mb: 2,
            display: 'grid',
            gap: '32px',
          }}
        >
          <Grid size={12} sx={{ gap: 20, marginTop: '35px' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px',
                mb: 2,
              }}
            >
              <Typography variant="h6">Mobile Assets</Typography>
              {(currentRecord.shiftStatusId === 0 ||
                currentRecord.shiftStatusId === 2) && (
                <AddButtonComponent
                  onClick={() => {
                    setAddMobileAssetDialogOpen(true);
                  }}
                  keyName="quoteaddicon"
                  label="Add New"
                />
              )}
            </Box>
            {shiftMobileAssets.length > 0 && (
              <TableContainer sx={{ mt: 2 }} component={Paper}>
                <Table className="">
                  <TableRow
                    className="headrowtbl"
                    key={'headrow_'}
                    style={{ background: ' rgba(0, 244, 255, 0.06)' }}
                  >
                    <TableCell key={'tblheadcllitemc_'} className="boldfont">
                      Asset Name
                    </TableCell>
                    <TableCell
                      key={'tblbotblheadclliqty_'}
                      className="boldfont"
                      sx={borderStyleLeft}
                    >
                      Plan Hours
                    </TableCell>
                    <TableCell
                      key={'tblbotblheadcllistarttime_'}
                      className="boldfont"
                      sx={borderStyleLeft}
                    >
                      Actual Hours
                    </TableCell>

                    <TableCell
                      colSpan={2}
                      key={'tblbotblheadclliplntotaltime_'}
                      className="boldfont"
                      sx={borderStyleLeft}
                    >
                      Review Hours
                    </TableCell>
                  </TableRow>
                  {shiftMobileAssets.map((item: any, index: any) => {
                    return (
                      <TableBody key={'tblbody_' + index}>
                        <TableRow key={'bodyrow_dtl_' + index + '_'}>
                          <TableCell style={{ whiteSpace: 'pre-wrap' }}>
                            {item.mobileAsset.assetName}
                          </TableCell>
                          <TableCell sx={borderStyleLeft}>
                            {currentRecord.shiftStatusId === 0 ? (
                              <SelectFieldComponent
                                label={''}
                                isRequired={false}
                                items={hoursList}
                                keyName={'FormBillable_plan_eM' + index}
                                name={'FormBillable_plan_eM' + index}
                                value={(
                                  Math.round(item.planMinutes) / 60
                                ).toString()}
                                onChange={(event) => {
                                  handleMinutesChange(
                                    event.target.value,
                                    index,
                                    'planMinutes'
                                  );
                                }}
                                errorStr={''}
                              />
                            ) : item.planMinutes ? (
                              item.planMinutes / 60
                            ) : (
                              '-'
                            )}
                          </TableCell>
                          <TableCell sx={borderStyleLeft}>
                            {item.actualMinutes
                              ? item.actualMinutes / 60
                              : item.actualMinutes !== 0
                                ? '-'
                                : item.actualMinutes}
                          </TableCell>
                          <TableCell
                            sx={{
                              width: '150px',
                              borderLeft: '1px solid #edeeed',
                            }}
                            key={'bodyrow_dtl_plan_endimetxt-' + index + '_'}
                          >
                            {currentRecord.shiftStatusId === 2 ||
                            currentRecord.shiftStatusId === 3 ? (
                              <SelectFieldComponent
                                label={''}
                                isRequired={false}
                                items={hoursList}
                                keyName={
                                  'FormBillable_plan_end_reviewMinutes' + index
                                }
                                name={
                                  'FormBillable_plan_end_reviewMinutes' + index
                                }
                                value={(
                                  Math.round(item.reviewMinutes) / 60
                                ).toString()}
                                onChange={(event) => {
                                  handleMinutesChange(
                                    event.target.value,
                                    index,
                                    'reviewMinutes'
                                  );
                                }}
                                errorStr={''}
                              />
                            ) : item.reviewMinutes ? (
                              item.reviewMinutes / 60
                            ) : (
                              '-'
                            )}
                          </TableCell>

                          {
                            <TableCell style={{ width: '100px' }}>
                              {currentRecord.shiftStatusId === 0 && (
                                <IconButton
                                  key={
                                    'bodyrow_dtl_cell_delet-icn-' + index + '_'
                                  }
                                  aria-label="delete"
                                  onClick={() => {
                                    removeItem(index);
                                  }}
                                  sx={boxStyle}
                                >
                                  <DeleteForeverIcon
                                    key={
                                      'bodyrow_dtl_cell_only-icn-' + index + '_'
                                    }
                                  />
                                </IconButton>
                              )}
                            </TableCell>
                          }
                        </TableRow>
                      </TableBody>
                    );
                  })}

                  {/* </TableBody> */}
                </Table>
              </TableContainer>
            )}
          </Grid>
          <Divider />
          <ShiftSaveButtons
            processing={processing}
            publishing={publishing}
            handleSave={handleSave}
            shiftStatus={currentRecord ? currentRecord.shiftStatusId : 0}
          />

          <SimpleDialogComponent
            title={''}
            dialogContent={MobileAssetDialogContent()}
            open={addMobileAssetDialogOpen}
            handleClose={() => {
              setAddMobileAssetDialogOpen(false);
            }}
          />
          <AlertMessageComponent
            type={'success'}
            open={httpError.open}
            handleClose={() => {
              setHttpError({ open: false, message: '' });
            }}
            message={httpError.message}
          />
        </Box>
      </Paper>
    );
  }
);

export default MobileAssets;
const boxStyle = {
  marginBottom: '15px',
};
const borderStyleRight = {
  borderRight: '1px solid #edeeed',
};
const borderStyleLeft = {
  borderLeft: ' 1px solid  #edeeed',
};
